module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "permissions__col__body__users__list__user",
    class: {
      index: _vm.index
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.source.default_thumb_url
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.source.name))])]), _vm._v(" "), _c('div', {
    staticClass: "role-change__selector role-change__selector__placeholder",
    class: {
      'role-change__selector--active': _vm.source.id === _vm.activeChangeId
    },
    attrs: {
      "data-user-id": _vm.source.id
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setChangeRole.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.permissions.change_role')) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2048d4bd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Permissions/PermissionsUser.vue
// module id = 1539
// module chunks = 1